import { AnalyticsClientGuidDto } from '../../interfaces/AnalyticsClientGuidDto';

export default function transformAnalyticsGuid(dto: AnalyticsClientGuidDto): AnalyticsClientGuidDto {
  heap?.resetIdentity();
  heap?.identify(dto?.analyticId);
  return dto;
}
